import { makeStyles } from '@material-ui/styles';
import { Theme } from '@bizzabo/design-system';
import {
    GetStreamUser,
    useGetBannedUsersByTimer,
    useChatClient,
    fetchUsersFromGetStream,
} from '@bizzabo/chat-core';
import EmptyBanUsersList from './EmptyBanUsersList';

import BanUsersList from './BanUsersList';
import { unBanUser } from '../../utils/userUtils';
import { UserRole } from '../../types/UserRole';
import { useEffect, useState } from 'react';

interface BanUsersViewProps {
    accountId: number;
    portalId: number;
    sessionId: number;
    chatUserRole: UserRole;
}

const BanUsersView: React.FC<BanUsersViewProps> = ({
    accountId,
    portalId,
    sessionId,
    chatUserRole,
}) => {
    const classes = useStyles();

    const [bannedUsersList, setBannedUsersList] = useState<GetStreamUser[]>([]);
    const { client } = useChatClient();
    const bannedUsersByTimer = useGetBannedUsersByTimer();

    const queryBannedUser = async () => {
        const users = await fetchUsersFromGetStream(client, { banned: true });
        setBannedUsersList(users);
    };

    useEffect(() => {
        setBannedUsersList(bannedUsersByTimer);
    }, [bannedUsersByTimer]);

    useEffect(() => {
        queryBannedUser();
    }, []);

    const unBanUserHandler = async userId => {
        await unBanUser(accountId, portalId, sessionId, userId);
        queryBannedUser();
    };

    return (
        <div className={classes.container}>
            {bannedUsersList.length === 0 ? (
                <EmptyBanUsersList />
            ) : (
                <BanUsersList
                    users={bannedUsersList}
                    chatUserRole={chatUserRole}
                    unBanUserTriggered={unBanUserHandler}
                />
            )}
        </div>
    );
};

const useStyles = makeStyles<Theme>(
    theme => ({
        container: {
            height: '100%',
            backgroundColor: theme.palette.greys['100'],
        },
    }),
    {
        classNamePrefix: 'BanUsersView',
    }
);

export default BanUsersView;
